module.exports = __webpack_public_path__ + "static/media/sanft.68e3d2f5.mp3";